<template>
  <system-storage-report />
</template>

<script>
import SystemStorageReport from '@/components/Reports/SystemStorageReport'

export default {
  components: {
    SystemStorageReport
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SystemStorage.vue?a7c2adf4